// extracted by mini-css-extract-plugin
export default {"container":"RxHz4Yh","button":"breiRmE TYb4J9A","locationText":"z6TXMJ2 fVdHxMU","changeLabel":"DOXKUAb Xa2O9TJ jFyrDfG","withLabels":"EGfsISy","pipe":"XKJ5IQs"};